import React from 'react';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'; // Slider stil dosyaları
import './HighschoolACP.css'; // Home.css dosyasını dahil ediyoruz
import mainImage from '../../assets/Algoritma.png'; // Resmin doğru yolu
function HighschoolACP() {
  const { t } = useTranslation();

  return (

    <div>

      <div className="empty-space"></div>
      <div className="empty-space_init"></div>
      <section data-type="component-text">

        <section className="container pt-5 pb-5">

          <div className="row">
            <div className="col-lg-6 col-sm-12 mb-5">
              <h2>{t('acp')}</h2>
              <h3><strong>{t('acp_sub_1')}</strong></h3>
              <h3><strong>{t('acp_sub_2')}</strong></h3>
              <h3><strong>{t('acp_sub_3')}</strong></h3>
              <h3><strong>{t('acp_sub_4')}</strong></h3>
              <h3><strong>{t('acp_sub_5')}</strong></h3>
              <div className="empty-space_mid"></div>
              <p>{t('acp_header')}</p>
              <li>{t('acp_main_1')}</li>
              <li>{t('acp_main_2')}</li>
              <li>{t('acp_main_3')}</li>
              <li>{t('acp_main_4')}</li>
              <div className="empty-space_init"></div>
              <div class="btn-group" role="group" aria-label="Third group">

                <button type="button" class="btn btn-purple-moon btn-rounded ">{t('acp_button_1')}</button>

                <button type="button" class="btn btn-purple-moon btn-rounded ">{t('acp_button_2')}</button>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <img src={mainImage} alt="MatBilim Logo" className="img-fluid" />
            </div>

          </div>
        </section>

      </section>

    </div>
  );
}

export default HighschoolACP;
